import { render } from "./home3.vue?vue&type=template&id=fa8250c4"
import script from "./home3.vue?vue&type=script&lang=js"
export * from "./home3.vue?vue&type=script&lang=js"

import "./home3.vue?vue&type=style&index=0&id=fa8250c4&lang=scss"
script.render = render

export default script